var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#48A49D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 34.4648C24.3165 34.8554 23.6834 34.8554 23.2928 34.4648L18.121 29.293C17.7305 28.9025 17.0974 28.9025 16.7068 29.293L15.293 30.7068C14.9025 31.0974 14.9025 31.7305 15.293 32.121L23.2928 40.1208C23.6834 40.5114 24.3165 40.5114 24.707 40.1208L42.7068 22.121C43.0974 21.7305 43.0974 21.0974 42.7068 20.7068L41.293 19.293C40.9025 18.9025 40.2694 18.9025 39.8788 19.293L24.707 34.4648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSuccess);
export default __webpack_public_path__ + "static/media/step_success.68377611d41f0a80cd52b42d91153f8b.svg";
export { ForwardRef as ReactComponent };